import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";
import { colors } from "./colors";

const config = defineConfig({
  globalCss: {
    html: {
      margin: 0,
      padding: 0,
      fontWeight: "normal",
    },
    "html h1": { letterSpacing: "-1px", textTransform: "uppercase" },
    "html h2": { letterSpacing: "-1px" },
    "html h3": { letterSpacing: "-1px" },
    body: {
      background: "#fafafa",
      minHeight: "100vh",
    },
    "a:hover": { textDecoration: "none" },
  },
  theme: {
    tokens: {
      colors: Object.fromEntries(
        Object.entries(colors).map(([scale, shades]) => [
          scale,
          Object.fromEntries(
            Object.entries(shades as Record<string, string>).map(([k, v]) => [
              k,
              { value: v },
            ])
          ),
        ])
      ),
      fonts: {
        heading: {
          value: `"HelveticaNeue", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica, Arial, sans-serif`,
        },
        body: {
          value: `"HelveticaNeue", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica, Arial, sans-serif`,
        },
      },
      fontWeights: {
        normal: { value: "400" },
        medium: { value: "400" },
        bold: { value: "400" },
      },
    },
    recipes: {
      button: {
        base: {
          fontWeight: "normal",
          borderRadius: "0px",
          fontFamily: "HelveticaNeue",
          cursor: "pointer",
        },
        variants: {
          variant: {
            outline: {
              border: "1px solid",
              borderColor: "palmNetwork.100",
              color: "palmNetwork.100",
              bg: "palmNetwork.200",
              _hover: {
                bg: "palmNetwork.100",
                color: "palmNetwork.200",
              },
            },
            solid: {
              border: "1px solid",
              borderColor: "palmNetwork.100",
              bg: "palmNetwork.100",
              color: "palmNetwork.200",
              _hover: {
                bg: "palmNetwork.200",
                color: "palmNetwork.100",
              },
              _active: {
                bg: "palmNetwork.500",
                color: "palmNetwork.200",
                transform: "scale(0.98)",
              },
            },
          },
        },
      },
    },
  },
});

export const system = createSystem(defaultConfig, config);
export default system;
